import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=5a2d4345&scoped=true"
import script from "./NotificationsBell.vue?vue&type=script&lang=js"
export * from "./NotificationsBell.vue?vue&type=script&lang=js"
import style0 from "./NotificationsBell.vue?vue&type=style&index=0&id=5a2d4345&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d4345",
  null
  
)

export default component.exports